import type {
  HttpError,
  IncentivesPayload,
  IncentivesRecord,
  RawIncentivesState
} from "./shared-types";

// Payload types are found in the lambda and its submodules as seen with the import types above
// Only adding the type guards here
//
export function isIncentivesPayload(object: any): object is IncentivesPayload {
  return object && "logicalStates" in object;
}

export function isHttpError(object: any): object is HttpError {
  return object && "name" in object && object.name === "HttpError";
}

export interface IncentivesManagerFetchInterface {
  resource: string;
  resourceId?: string;
  asAccount?: string;
  asUser?: string;
  locale?: string;
  extraURLParams?: string;
  isMock?: boolean;
  disabled?: boolean; // Added to control whether the query should be enabled
}

export interface IncentivesManagerFetchWriteInterface {
  resource: string;
  resourceId?: string;
  asAccount?: string;
  asUser?: string;
  locale?: string;
  afterSuccess?:
    | ((data: IncentivesRecord | RawIncentivesState[]) => void)
    | string; // Either a function to take retured data or a string representing the resource to invalidate
}

export interface EditIncentivesDisableFlags {
  disableTypeEditing: boolean;
  publisherMode: boolean;
  published: boolean;
  readOnly: boolean;
  disableDistributionLists: boolean;
  dealerStackOptionEnabled: boolean;
  dealerStackOptionChecked: boolean;
  hideDistributionLists: boolean;
}

export * from "./ddc-pages-incentives-manager-interface-mock";
